export const AUTH_VERIFICATION_STATE_KEY = 'pp_auth_verification_state';

const PENDING = 'pending';
const FAILED = 'failed';

function writeState(state) {
  try {
    window.sessionStorage.setItem(AUTH_VERIFICATION_STATE_KEY, state);
  } catch {
    // Session storage can be unavailable in restricted browser contexts.
  }
}

export function markAuthVerificationPending() {
  writeState(PENDING);
}

export function markAuthVerificationFailed() {
  writeState(FAILED);
}

export function isAuthVerificationFailed() {
  try {
    return window.sessionStorage.getItem(AUTH_VERIFICATION_STATE_KEY) === FAILED;
  } catch {
    return false;
  }
}

export function clearAuthVerificationState() {
  try {
    window.sessionStorage.removeItem(AUTH_VERIFICATION_STATE_KEY);
  } catch {
    // Session storage can be unavailable in restricted browser contexts.
  }
}

export function isAuthVerificationBlockingRedirect() {
  try {
    const state = window.sessionStorage.getItem(AUTH_VERIFICATION_STATE_KEY);
    return state === PENDING || state === FAILED;
  } catch {
    return false;
  }
}
